// extracted by css-extract-rspack-plugin
export default {"input":"input-_bie4E","textarea":"textarea-pPIGis"};